module.exports = __webpack_public_path__ + "static/media/ffhb.43b1c33a.png";